import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        nav(data.role === "admin" ? "/admin" : "/dashboard");
      } catch { nav("/login"); }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-eon-bg">
      <div className="text-center">
        <div className="font-display text-3xl font-black tracking-tighter">E.O.N</div>
        <div className="eon-label mt-3">Signing you in...</div>
      </div>
    </div>
  );
}
